"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunFaucetResponseToJSON = exports.RunFaucetResponseFromJSONTyped = exports.RunFaucetResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function RunFaucetResponseFromJSON(json) {
    return RunFaucetResponseFromJSONTyped(json, false);
}
exports.RunFaucetResponseFromJSON = RunFaucetResponseFromJSON;
function RunFaucetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'txId': !runtime_1.exists(json, 'txId') ? undefined : json['txId'],
        'txRaw': !runtime_1.exists(json, 'txRaw') ? undefined : json['txRaw'],
    };
}
exports.RunFaucetResponseFromJSONTyped = RunFaucetResponseFromJSONTyped;
function RunFaucetResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'txId': value.txId,
        'txRaw': value.txRaw,
    };
}
exports.RunFaucetResponseToJSON = RunFaucetResponseToJSON;
//# sourceMappingURL=RunFaucetResponse.js.map